import { useState, useEffect } from 'react';
import "./NewTagModal.css";
import Modal from "../shared/Modal";

type NewTagModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (name: string) => void;
}

export const NewTagModal = ({isOpen, onClose, onSubmit}: NewTagModalProps) => {

    const [name, setName] = useState<string>("");

    return (
        <Modal
            isOpen={isOpen}
            style={null}
            onClose={onClose}
            canClose={true}
            allowClickout={true}
        >
            <div className="new-tag-container">

                <div className="modal-title">
                    New tag
                </div>

                <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    autoFocus={true}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            onSubmit(name);
                        }
                    }}
                />


                <div className="modal-buttons">
                    <button 
                        className="button-cancel"
                        onClick={onClose}
                    > 
                        Cancel
                    </button>

                    <button
                        className="button-save"
                        onClick={() => {
                            onSubmit(name);
                        }}
                        disabled={name === ""}
                    >
                        Submit
                    </button>
                </div>
                

              
            </div>
      </Modal>
    )
}